<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
    fxLayoutGap="30px"
    *ngIf="persona"
>
    <div style="min-width: 150px">
        <img
            *ngIf="fotoPerfil"
            [src]="fotoPerfil"
            alt=""
            class="avatar-imagen"
        />
    </div>
    <div>
        <mat-list>
            <mat-list-item>
                <h3 matLine>Nombre</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ persona.nombres }}, {{ persona.apellidos }}
                    </span>
                </p>
                <span matLine class="secondary-text">{{
                    persona.rut
                }}</span>
            </mat-list-item>

            <!-- mat-list-item>
                <h3 matLine>Correo electrónico</h3>
                <p matLine>
                    <span class="secondary-text">{{ persona.email }}</span>
                </p>
            </mat-list-item -->

        </mat-list>
    </div>

</div>
